import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import useDelayedInputOnchange from 'src/hooks/useDelayedInputOnchange';
import { isNullOrUndefined } from 'src/utils';

const QuantityReceiveCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const { errors = [] } = dataItem;
  const isDisabled = !dataItem.selected;
  const { handleChange, value } = useDelayedInputOnchange(props);
  return (
    <GridCellBase {...props} className={'!bg-transparent'} title={value}>
      <div className="flex items-center gap-2">
        <span className="text-black">=</span>
        <NumberInput
          value={isNullOrUndefined(value) ? '' : value}
          onChange={handleChange}
          disabled={isDisabled}
          width="100%"
          valid={!errors.length}
        />
      </div>
    </GridCellBase>
  );
};

export default QuantityReceiveCell;
